import React from 'react'

import { hasValue } from '../../../../utils/helpers/value'

const areEquals = (prev, next) => {
  return prev.watch === next.watch
}

const Refresher = React.memo(({ children, watch, delay }) => {
  const [show, setShow] = React.useState(false)

  React.useEffect(() => {
    setShow(false)
    if (delay !== false) {
      setTimeout(() => setShow(true), delay || 50)
    }
  }, [watch])

  if (delay !== false && !show) return false

  return children
}, areEquals)

export default Refresher
